import React, { useState, useEffect } from 'react';
import HeaderContent from "components/Header/Content";
import NavBar from 'components/Header/NavBar';
import AppDownload from './AppDownload';
import {addClass, removeClass} from 'utils';
import CMSService from 'services/CMS/';
import RenderService from 'services/Render';
import PreHeader from 'components/Header/PreHeader';
import useVariant from 'hooks/useVariant';
import { searchVariantID } from 'config';
import { ecommerce } from 'config/constants';
import { throttle } from 'utils'
import style from './style.scss';//NOSONAR

let firstPosition = 0;

const getInitialState = () => {
    let renderData =  RenderService.getRenderData();

    if(!(renderData && renderData.menu)){
        return {};
    }

    const data = CMSService.getMenuFiltred(renderData.menu);

    return {
        categories: data.acf.items,
        fixedCategories: data.acf.fixed_categories,
        offers: data.acf.offers
    };
}

const NewHeader = () => {
    const initialState = getInitialState();
    const [categories, setCategories] = useState(initialState.categories || []);
    const [sticky, setSticky] = useState(false);
    const [fixedCategories, setFixedCategories] = useState(initialState.fixedCategories || []);
    const [offers, setOffers] = useState(initialState.offers || []);

    const variant = useVariant(searchVariantID);
    const newVariant = variant === '1';

    useEffect(() => {
        if(typeof window !== 'undefined'){
            window.addEventListener('scroll', throttle(scrolling, 40));
        }

        CMSService.getMenu().then(results => {
            if(!results) return false;
            
            const {items} = results.acf;
            const fixedCats = results.acf.fixed_categories;
            const offers = results.acf.offers || [];

            setCategories(items);
            setFixedCategories(fixedCats);
            setOffers(offers)
        });

        addClass(document.body, 'new-home');

        return function cleanup(){
            removeClass(document.body, 'new-home');
            window.removeEventListener('scroll', throttle(scrolling, 200));
        }
    }, []);

    const scrolling = () =>{
        const sY = window.scrollY;

        if(firstPosition < 0) {
            firstPosition = 0;
        }

        if(sY > firstPosition){
            setSticky(true);
        }else{
            setSticky(false);
        }

        firstPosition = sY;
    }

    useEffect(() => {
        if(!sticky){
            addClass(document.body, 'pre-header');
        }

        if(newVariant) {
            addClass(document.body, 'variant');
        }
        
        return function cleanup(){
            removeClass(document.body, 'pre-header');

            if(newVariant) {
                removeClass(document.body,'variant');
            }
        }
    }, [sticky]);


    return <header className={'new-header'+(sticky ? ' sticky': '')}>
        {!ecommerce.whiteLabel && <AppDownload sticky={sticky} />}
        <PreHeader />
        <HeaderContent categories={categories} fixedCategories={fixedCategories} offers={offers}/>
        <NavBar categories={categories} fixedCategories={fixedCategories} offers={offers}/>
    </header>;
};

export default NewHeader;
